import axios from "@/assets/http";

export default {
    reportPushClick(data) {
        // 点击上报仅用于推送阅读统计与未读短信判定，不能影响落地页浏览。
        return axios.post("/api/v3/frontend/landlordHostingPush/click", data, { silent: true });
    },
    getClientVersion(data) {
        return axios.post("/api/v3/frontend/landlordHostingPush/clientVersion", data, { silent: true });
    },
    getContactWecom() {
        return axios.get("/api/v3/frontend/landlordHostingPush/contactWecom", { silent: true });
    },
};
